import { apiServices as baseApiServices } from '../services';
import createEntityApiMiddleware, {
  EntityApiMiddlewareType,
} from './createEntityApiMiddleware';

export default function getApiMiddlewares(
  apiSettings,
  additionalApiServices = {},
  setAlert = payload => {
    console.log('setAlert!!', payload);
  }
) {
  const middlewares: Record<string, EntityApiMiddlewareType> = {};
  if (!apiSettings) return middlewares;

  const apiServices = { ...baseApiServices, ...additionalApiServices };

  for (const entityIdCamelized in apiServices) {
    middlewares[entityIdCamelized] = createEntityApiMiddleware(
      entityIdCamelized,
      apiSettings,
      apiServices,
      setAlert
    );
  }

  return middlewares;
}
